<template>
  <div>
    <h1>This is the First Route</h1>
    <p>Welcome to the first route!</p>
  </div>
</template>
